import { component } from 'vue-form-generator';
// import 'vue-form-generator/dist/vfg.css';

import customObjectData from '@/data/custom-object-schema';

export default {
  name: 'CustomObjectAddRelationship',

  components: {
    VueFormGenerator: component,
  },

  data() {
    return {
      relationship: {
        model: customObjectData.newRelationship.model,
        schema: customObjectData.newRelationship.schema,
        formOptions: customObjectData.newRelationship.formOptions,
      },
    };
  },

  methods: {
    createNewObject() {
      this.$router.push({ name: 'edit-custom-object' });
    },
  },
};
